type Props = {
  children: any | JSX.Element | JSX.Element[];
  className?: string;
};

const PageContainer = ({ children, className }: Props) => <div className={className}>{children}</div>;

export default PageContainer;
